import { css } from 'linaria';

export const constructionHousesBenefitsSection = css`
  && {
    margin-top: 80px;

  @media (--from-tablet) and (--to-largeDesktop) {      margin-top: 64px;
    }

    @media (--only-mobile) {
      margin-top: 40px;
    }
  }
`;

export const constructionHousesBenefitsList = css`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding: 0;
  margin: 0;
  column-gap: 24px;
  list-style: none;

  @media (--only-tablet) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 112px 112px;
    column-gap: 24px;
    row-gap: 16px;
  }

  @media (--only-mobile) {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: auto;
    column-gap: 0;
    row-gap: 24px;
  }
`;

export const constructionHousesBenefitsText = css`
  width: 160px;
  margin-top: 16px;

  @media (--only-mobile) {
    width: auto;
  }
`;
